<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-field">
      <input-text
        elem-id="soProductFiscalNcm"
        v-model="formData.so_product_fiscal_ncm"
        :label="t('NCM')"
        :placeholder="inheritedPlaceholder('so_product_fiscal_ncm') || t('Ex: 12345678')"
        :validation="() => isValidNcmCode(formData.so_product_fiscal_ncm)"
        :maxlength="8"
        required
        fluid
        data-testid="so-catalog-fiscal-ncm-input"
      />
      <small v-if="errors.ncm" class="error-message">{{ errors.ncm }}</small>
      <small
        v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_ncm')"
        class="inherited-hint"
        data-testid="so-catalog-fiscal-inherited-ncm"
      >
        {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_ncm') }}
      </small>
    </div>

    <div class="flex-container">
      <div class="flex-item-half">
        <div class="form-field">
          <input-text
            elem-id="soProductFiscalCest"
            v-model="formData.so_product_fiscal_cest"
            :label="t('CEST')"
            :placeholder="inheritedPlaceholder('so_product_fiscal_cest')"
            fluid
            data-testid="so-catalog-fiscal-cest-input"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_cest')"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-cest"
          >
            {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_cest') }}
          </small>
        </div>
      </div>

      <div class="flex-item-half">
        <div class="form-field">
          <select-list
            elem-id="soProductFiscalOrigem"
            v-model="formData.so_product_fiscal_origem"
            :itens-select="origemOptions"
            :label="t('Origem da mercadoria')"
            :placeholder="inheritedOrigemLabel || t('Selecione a origem')"
            :auto-select-first="false"
            data-testid="so-catalog-fiscal-origem-select"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedOrigemLabel"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-origem"
          >
            {{ t('Valor atual:') }} {{ inheritedOrigemLabel }}
          </small>
        </div>
      </div>
    </div>

    <div class="flex-container">
      <div class="flex-item-half">
        <div class="form-field">
          <input-text
            elem-id="soProductFiscalCfopDentroUf"
            v-model="formData.so_product_fiscal_cfop_dentro_uf"
            :label="t('CFOP dentro da UF')"
            :placeholder="inheritedPlaceholder('so_product_fiscal_cfop_dentro_uf')"
            fluid
            data-testid="so-catalog-fiscal-cfop-dentro-uf-input"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_cfop_dentro_uf')"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-cfop-dentro-uf"
          >
            {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_cfop_dentro_uf') }}
          </small>
        </div>
      </div>

      <div class="flex-item-half">
        <div class="form-field">
          <input-text
            elem-id="soProductFiscalCfopForaUf"
            v-model="formData.so_product_fiscal_cfop_fora_uf"
            :label="t('CFOP fora da UF')"
            :placeholder="inheritedPlaceholder('so_product_fiscal_cfop_fora_uf')"
            fluid
            data-testid="so-catalog-fiscal-cfop-fora-uf-input"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_cfop_fora_uf')"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-cfop-fora-uf"
          >
            {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_cfop_fora_uf') }}
          </small>
        </div>
      </div>
    </div>

    <div class="flex-container">
      <div class="flex-item-half">
        <div class="form-field">
          <input-text
            elem-id="soProductFiscalCst"
            v-model="formData.so_product_fiscal_cst"
            :label="t('CST')"
            :placeholder="inheritedPlaceholder('so_product_fiscal_cst')"
            fluid
            data-testid="so-catalog-fiscal-cst-input"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_cst')"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-cst"
          >
            {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_cst') }}
          </small>
        </div>
      </div>

      <div class="flex-item-half">
        <div class="form-field">
          <input-text
            elem-id="soProductFiscalCsosn"
            v-model="formData.so_product_fiscal_csosn"
            :label="t('CSOSN')"
            :placeholder="inheritedPlaceholder('so_product_fiscal_csosn')"
            fluid
            data-testid="so-catalog-fiscal-csosn-input"
          />
          <small
            v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_csosn')"
            class="inherited-hint"
            data-testid="so-catalog-fiscal-inherited-csosn"
          >
            {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_csosn') }}
          </small>
        </div>
      </div>
    </div>

    <div class="form-field">
      <input-text
        elem-id="soProductFiscalUnidadeTributavel"
        v-model="formData.so_product_fiscal_unidade_tributavel"
        :label="t('Unidade tributável')"
        :placeholder="inheritedPlaceholder('so_product_fiscal_unidade_tributavel')"
        fluid
        data-testid="so-catalog-fiscal-unidade-tributavel-input"
      />
      <small
        v-if="props.scope === 'franquia' && inheritedPlaceholder('so_product_fiscal_unidade_tributavel')"
        class="inherited-hint"
        data-testid="so-catalog-fiscal-inherited-unidade-tributavel"
      >
        {{ t('Valor atual:') }} {{ inheritedPlaceholder('so_product_fiscal_unidade_tributavel') }}
      </small>
    </div>
  </form>
</template>

<script setup lang="ts">
import { reactive, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { emitValidationFailed } from '../../composables/useFormValidation';
import { useSOCatalogFiscal, type FiscalScope } from '../../composables/useSOCatalogFiscal';
import { isValidNcmCode } from './fiscalCodeValidation';
import type { So_ProductFiscalEffectiveRow } from '../../contracts/So_ProductFiscalEffectiveRow';
import { log, error as logError } from '../../utils/DebugLogger';

type Id = number | string;

interface Props {
  itemId?: Id | null;
  franchiseId?: number;
  scope: FiscalScope;
  effective: So_ProductFiscalEffectiveRow | null;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'submit-success': [];
  'submit-error': [error: unknown];
}>();

const { t } = useI18n();
const { salvarProductFiscal } = useSOCatalogFiscal();

// Fixed origem-da-mercadoria table (CST origin, 0-8) — same list used by
// so-service-priorities/CloneToFranchiseModal.vue's fixed-{ID,Name} pattern.
const origemOptions = computed(() => [
  { ID: 0, Name: t('0 — Nacional') },
  { ID: 1, Name: t('1 — Estrangeira, importação direta') },
  { ID: 2, Name: t('2 — Estrangeira, adquirida no mercado interno') },
  { ID: 3, Name: t('3 — Nacional, conteúdo de importação > 40%') },
  { ID: 4, Name: t('4 — Nacional, processo produtivo básico') },
  { ID: 5, Name: t('5 — Nacional, conteúdo de importação <= 40%') },
  { ID: 6, Name: t('6 — Estrangeira, importação direta, sem similar nacional') },
  { ID: 7, Name: t('7 — Estrangeira, mercado interno, sem similar nacional') },
  { ID: 8, Name: t('8 — Nacional, conteúdo de importação > 70%') },
]);

const formData = reactive<{
  so_product_fiscal_ncm?: string;
  so_product_fiscal_cest?: string;
  so_product_fiscal_cfop_dentro_uf?: string;
  so_product_fiscal_cfop_fora_uf?: string;
  so_product_fiscal_cst?: string;
  so_product_fiscal_csosn?: string;
  so_product_fiscal_origem?: number;
  so_product_fiscal_unidade_tributavel?: string;
}>({});

const errors = reactive({ ncm: '' });

const clearErrors = (): void => {
  errors.ncm = '';
};

const inheritedPlaceholder = (field: keyof So_ProductFiscalEffectiveRow): string => {
  if (!props.effective) return '';
  const v = props.effective[field];
  return v === undefined || v === null ? '' : String(v);
};

const inheritedOrigemLabel = computed<string>(() => {
  if (!props.effective || props.effective.so_product_fiscal_origem == null) return '';
  const found = origemOptions.value.find((o) => o.ID === props.effective!.so_product_fiscal_origem);
  return found ? found.Name : String(props.effective.so_product_fiscal_origem);
});

const resetForm = (): void => {
  formData.so_product_fiscal_ncm = undefined;
  formData.so_product_fiscal_cest = undefined;
  formData.so_product_fiscal_cfop_dentro_uf = undefined;
  formData.so_product_fiscal_cfop_fora_uf = undefined;
  formData.so_product_fiscal_cst = undefined;
  formData.so_product_fiscal_csosn = undefined;
  formData.so_product_fiscal_origem = undefined;
  formData.so_product_fiscal_unidade_tributavel = undefined;
  clearErrors();
};

const populateForm = (): void => {
  resetForm();
  if (props.scope === 'global' && props.effective) {
    formData.so_product_fiscal_ncm = props.effective.so_product_fiscal_ncm;
    formData.so_product_fiscal_cest = props.effective.so_product_fiscal_cest;
    formData.so_product_fiscal_cfop_dentro_uf = props.effective.so_product_fiscal_cfop_dentro_uf;
    formData.so_product_fiscal_cfop_fora_uf = props.effective.so_product_fiscal_cfop_fora_uf;
    formData.so_product_fiscal_cst = props.effective.so_product_fiscal_cst;
    formData.so_product_fiscal_csosn = props.effective.so_product_fiscal_csosn;
    formData.so_product_fiscal_origem = props.effective.so_product_fiscal_origem;
    formData.so_product_fiscal_unidade_tributavel = props.effective.so_product_fiscal_unidade_tributavel;
  }
};

watch(() => [props.effective, props.scope, props.itemId], populateForm, { immediate: true });

const validateForm = (): boolean => {
  clearErrors();
  let isValid = true;

  if (!isValidNcmCode(formData.so_product_fiscal_ncm)) {
    errors.ncm = t('NCM obrigatório, com 8 dígitos (ex: 12345678)');
    isValid = false;
  }

  if (!isValid) {
    emitValidationFailed('SOCatalogFiscalProductForm', errors);
    return false;
  }
  return true;
};

const handleSubmit = async (): Promise<void> => {
  log('SOCatalogFiscalProductForm', 'handleSubmit', 'Form submitted');
  if (!validateForm() || props.itemId == null) {
    return;
  }

  try {
    await salvarProductFiscal({
      productId: Number(props.itemId),
      scope: props.scope,
      franchiseId: props.franchiseId,
      fields: {
        ncm: formData.so_product_fiscal_ncm,
        cest: formData.so_product_fiscal_cest,
        cfop_dentro_uf: formData.so_product_fiscal_cfop_dentro_uf,
        cfop_fora_uf: formData.so_product_fiscal_cfop_fora_uf,
        cst: formData.so_product_fiscal_cst,
        csosn: formData.so_product_fiscal_csosn,
        origem: formData.so_product_fiscal_origem,
        unidade_tributavel: formData.so_product_fiscal_unidade_tributavel,
      },
    });
    eventBus.emit('globalMessage.success', t('Dados fiscais do produto salvos com sucesso'));
    emit('submit-success');
  } catch (err: unknown) {
    logError('SOCatalogFiscalProductForm', 'handleSubmit', 'Error', err);
    const message = err instanceof Error ? err.message : '';
    eventBus.emit('globalMessage.error', t('Erro ao salvar dados fiscais do produto') + ': ' + message);
    emit('submit-error', err);
  }
};

defineExpose({ handleSubmit, validateForm, resetForm });
</script>

<style scoped>
.flex-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.flex-item-half {
  flex: 1;
  min-width: 0;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1rem;
}

.error-message {
  color: var(--p-red-500);
  font-size: 0.875rem;
}

.inherited-hint {
  color: var(--p-text-muted-color);
  font-size: 0.8rem;
}
</style>
